import { render } from "./EventsTodo.vue?vue&type=template&id=9901a6dc&scoped=true"
import script from "./EventsTodo.vue?vue&type=script&lang=js"
export * from "./EventsTodo.vue?vue&type=script&lang=js"

import "./EventsTodo.vue?vue&type=style&index=0&id=9901a6dc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9901a6dc"]])

export default __exports__